import { Row, Col } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { numberFormat } from '../../utils/display';
import ScgFamilyConnectModal from '../scgFamily/scgFamilyConnectModal';
import styles from './index.module.scss';

const SubNavbarSCGFamily = () => {
  const user = useSelector((state: any) => state.user);
  const [showBlock, setShowBlock] = useState<any>(true);
  const [isSCGFamilyConnected, setIsSCGFamilyConnected] =
    useState<any>(false);

  useEffect(() => {
    if (user && user?.scgFamily && user?.scgFamily?.scgId) {
      setIsSCGFamilyConnected(true);
    }
  }, [user]);

  return (
    <>
      {showBlock && (
        <>
          <div style={{ paddingTop: '16px' }}></div>
          {isSCGFamilyConnected ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Row>
                <img
                  style={{ width: "34px", height: "28px" }}
                  src="/images/scg-family.png"
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: "auto",
                    margin: "0 1rem",
                  }}
                >
                  <div>
                    <div
                      style={{ fontWeight: "bold" }}
                      className={styles.pointFlex}
                    >
                      SCG Family คะแนนคงเหลือ{" "}
                      {user.scgFamily &&
                        user.scgFamily.pointSummary &&
                        numberFormat(user.scgFamily.pointSummary.totalpoint)}
                    </div>
                    <Paragraph className={styles.pointFlex}>
                      คะแนนใกล้หมดอายุ{" "}
                      {user.scgFamily &&
                        user.scgFamily.pointSummary &&
                        numberFormat(
                          user.scgFamily.pointSummary.soonexpirepoint
                        )}
                    </Paragraph>
                  </div>
                  <div>
                    <div
                      style={{ fontWeight: "bold", color: "red" }}
                      className={styles.pointFlex}
                    >
                      &nbsp;
                    </div>
                    <div className={styles.pointFlex}> &nbsp;</div>
                  </div>
                </div>
                &nbsp;
                <img
                  style={{
                    width: "10px",
                    height: "10px",
                  }}
                  src="/images/close.png"
                  onClick={() => {
                    setShowBlock(false);
                  }}
                />
              </Row>
            </div>
          ) : (
            <div
              className={styles.scgFamCheckbox}
              style={{
                display: "flex",
                justifyContent: "center",
                // flexFlow: "row wrap",
                // paddingTop: '65px',
                // marginLeft: '10px',
                margin: "65px auto 5px auto",
                maxWidth: "1200px",
              }}
            >
              <Row style={{
                  border: "1px solid rgba(0, 0, 0, 0.2)",
                  borderRadius: "4px",
                  margin: "0px 5px 5px 5px",
                 }}>
                <img
                  style={{ width: "34px", height: "28px", margin: "10px" }}
                  src="/images/scg-family.png"
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "auto",
                    margin: "0 1rem",
                  }}
                >
                  <div style={{ fontWeight: "bold", marginTop: "5px" }}>
                    SCG Family
                  </div>
                  <Paragraph className={styles.textFlex}>
                    สะสมคะแนนและรับสิทธิประโยชน์มากมาย
                  </Paragraph>
                </div>
                <div
                  style={{
                    justifyContent: "flex-end",
                    borderRadius: "5px",
                    margin: "5px"
                  }}
                >
                  <ScgFamilyConnectModal />
                </div>
                <img
                  style={{
                    width: "10px",
                    height: "10px",
                    justifyContent: "flex-end",
                    margin: "5px 3px 0px 3px"
                  }}
                  src="/images/close.png"
                  onClick={() => {
                    setShowBlock(false);
                  }}
                />
              </Row>
              {/* <Row>
                <Col xs={3}>
                  <div
                    className={`${styles.filterText} ${styles.recommend}`}
                    // style={{ display: "flex" }}
                  >
                    <img
                      style={{
                        width: "34px",
                        height: "28px",
                        marginTop: "5px",
                      }}
                      src="/images/scg-family.png"
                    />
                  </div>
                </Col>
                <Col xs={15}>
                  <div
                    className={`${styles.filterText} ${styles.recommend} ${styles.option}`}
                    style={{ display: "flex" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: "auto",
                        margin: "0 1rem",
                      }}
                    >
                      <div style={{ fontWeight: "bold", marginTop: "5px" }}>
                        SCG Family
                      </div>
                      <Paragraph className={styles.textFlex}>
                        สะสมคะแนนและรับสิทธิประโยชน์มากมาย
                      </Paragraph>
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                <div
                  style={{
                    justifyContent: "flex-end",
                    borderRadius: "5px",
                    marginTop: "5px"
                  }}
                >
                  <ScgFamilyConnectModal />
                </div>
                <img
                  style={{
                    width: "10px",
                    height: "10px",
                    justifyContent: "flex-end",
                    margin: "5px 0px 0px 3px"
                  }}
                  src="/images/close.png"
                  onClick={() => {
                    setShowBlock(false);
                  }}
                />
                </Col>
              </Row> */}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SubNavbarSCGFamily;
